import { getDealAndObjectType } from './getDealAndObjectType';

export const getAnalyticsCategory = (category: string | undefined) => {
  const { dealType, objectType } = getDealAndObjectType(category);

  return [dealType, objectType].filter(Boolean).join('/') || undefined;
};
